import React, { Fragment, useState, useEffect } from 'react';
import Page from '../../Page';
import { ID_ACCESSIBILITY_PAGE } from '../../../css-api';
import { getLocale } from '../../../selectors/router';
import { useSelector } from 'react-redux';
import AccessibilityText_de from './accessibility_de';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  main: {
    padding: '2em 2em 4em',
    background: '#f1f1f1',
  },
}));

const Accessibility = () => {
  const classes = useStyles();
  const [AccessibilityText, setAccessibilityText] = useState();
  let localeId = useSelector(getLocale);
  useEffect(() => {
    import(`./accessibility_${localeId}.js`)
      .then((imp) => {
        setAccessibilityText(imp.default);
      })
      .catch(() => setAccessibilityText(AccessibilityText_de));
  });
  return (
    <Fragment>
      <Page
        id={ID_ACCESSIBILITY_PAGE}
        alignSelf="center"
        localeId={localeId}
        classNames={classes.main}
      >
        {AccessibilityText}
      </Page>
    </Fragment>
  );
};

export default Accessibility;
